/* creoMi theme — global behaviors */
(function () {
  'use strict';

  /* ---------- Toast ---------- */
  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'toast';
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('show'); });
    setTimeout(function () {
      t.classList.remove('show');
      setTimeout(function () { t.remove(); }, 300);
    }, 300);
  }
  window.creomiToast = toast;

  /* ---------- Money formatting ---------- */
  function formatMoney(cents) {
    var amount = (cents / 100);
    // JPY: no decimals, comma separators
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'JPY') {
      return '¥' + Math.round(amount).toLocaleString('ja-JP');
    }
    return '¥' + Math.round(amount).toLocaleString('ja-JP');
  }
  window.creomiMoney = formatMoney;

  /* ---------- Header scroll + mobile menu ---------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var hasHero = header.getAttribute('data-has-hero') === 'true';

    function onScroll() {
      var scrolled = window.scrollY > 60;
      if (hasHero) {
        header.classList.toggle('is-solid', scrolled);
        header.classList.toggle('text-dark', scrolled);
        header.classList.toggle('text-light', !scrolled);
      }
    }

    if (hasHero) {
      header.classList.add('text-light');
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    } else {
      header.classList.add('no-hero', 'text-dark');
    }

    var burger = header.querySelector('[data-burger]');
    var menu = document.querySelector('[data-mobile-menu]');

    if (burger && menu) {
      burger.addEventListener('click', function () {
        menu.classList.toggle('open');
      });

      menu.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          menu.classList.remove('open');
        });
      });
    }
  }

  /* ---------- Fade-up on scroll ---------- */
  function initFadeUp() {
    var els = document.querySelectorAll('.fade-up');

    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('visible');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = el.getAttribute('data-delay');

          if (delay) {
            el.style.transitionDelay = delay + 'ms';
          }

          el.classList.add('visible');
          io.unobserve(el);
        }
      });
    }, { threshold: 0.1 });

    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- Hero slider ---------- */
  function initHero() {
    var hero = document.querySelector('[data-hero]');
    if (!hero) return;

    var slides = hero.querySelectorAll('[data-hero-slide]');
    var dots = hero.querySelectorAll('[data-hero-dot]');

    if (slides.length <= 1) return;

    var current = 0;
    var timer;

    function go(i) {
      current = (i + slides.length) % slides.length;

      slides.forEach(function (s, idx) {
        s.classList.toggle('active', idx === current);

        var content = s.querySelector('.hero-anim-target');

        if (content && idx === current) {
          content.classList.remove('hero-anim');
          void content.offsetWidth;
          content.classList.add('hero-anim');
        }
      });

      dots.forEach(function (d, idx) {
        d.classList.toggle('active', idx === current);
      });
    }

    function next() {
      go(current + 1);
    }

    function prev() {
      go(current - 1);
    }

    function restart() {
      clearInterval(timer);
      timer = setInterval(next, 5000);
    }

    var prevBtn = hero.querySelector('[data-hero-prev]');
    var nextBtn = hero.querySelector('[data-hero-next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        restart();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        restart();
      });
    }

    dots.forEach(function (d, idx) {
      d.addEventListener('click', function () {
        go(idx);
        restart();
      });
    });

    restart();
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    document.querySelectorAll('[data-faq-q]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item');
        var ans = item.querySelector('.faq-a');
        var isOpen = item.classList.toggle('open');

        ans.style.maxHeight = isOpen ? ans.scrollHeight + 'px' : '0';
      });
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty-wrap]').forEach(function (wrap) {
      var input = wrap.querySelector('input');

      wrap.querySelectorAll('[data-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = parseInt(b.getAttribute('data-qty-btn'), 10);
          var val = Math.max(
            1,
            (parseInt(input.value, 10) || 1) + step
          );

          input.value = val;

          input.dispatchEvent(
            new Event('change', { bubbles: true })
          );
        });
      });
    });
  }

  /* ---------- AJAX Cart ---------- */
  var Cart = {

    get: function () {
      return fetch('/cart.js', {
        headers: {
          'Accept': 'application/json'
        }
      }).then(function (r) {
        return r.json();
      });
    },

    add: function (items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      }).then(function (r) {
        if (!r.ok) {
          return r.json().then(function (e) {
            throw e;
          });
        }

        return r.json();
      });
    },

    change: function (key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: qty
        })
      }).then(function (r) {
        return r.json();
      });
    }
  };

  window.creomiCart = Cart;

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? '(' + count + ')' : '';
    });
  }

  function renderDrawer(cart) {
    var itemsEl = document.querySelector('[data-drawer-items]');
    var footEl = document.querySelector('[data-drawer-subtotal]');

    if (!itemsEl) return;

    updateCartCount(cart.item_count);

    if (footEl) {
      footEl.textContent = formatMoney(cart.total_price);
    }

    if (!cart.items.length) {
      itemsEl.innerHTML =
        '<p class="cart-note" style="padding:2rem 0;text-align:center;">カートに商品がありません。</p>';
      return;
    }

    var html = '';

    cart.items.forEach(function (item) {
      html += '' +
        '<div class="drawer-line" data-line-key="' + item.key + '">' +

          '<a class="drawer-line__media" href="' + item.url + '">' +
            (item.image
              ? '<img src="' + item.image + '" alt="' + (item.product_title || '') + '">'
              : '') +
          '</a>' +

          '<div>' +
            '<a class="cart-row__title" href="' + item.url + '">' +
              item.product_title +
            '</a>' +

            (item.variant_title && item.variant_title !== 'Default Title'
              ? '<div class="cart-row__variant">' + item.variant_title + '</div>'
              : '') +

            '<div class="flex items-center gap-2" style="margin-top:.5rem;">' +
              '<div class="qty-wrap" data-qty-wrap style="border-color:var(--border);">' +

                '<button class="qty-btn" type="button" data-drawer-dec>−</button>' +

                '<span class="qty-input" style="display:inline-flex;align-items:center;justify-content:center;">' +
                  item.quantity +
                '</span>' +

                '<button class="qty-btn" type="button" data-drawer-inc>+</button>' +

              '</div>' +
            '</div>' +
          '</div>' +

          '<div style="text-align:right;">' +
            '<div class="cart-row__price">' +
              formatMoney(item.final_line_price) +
            '</div>' +

            '<button class="link-remove" type="button" data-drawer-remove>削除</button>' +
          '</div>' +

        '</div>';
    });

    itemsEl.innerHTML = html;

    itemsEl.querySelectorAll('[data-line-key]').forEach(function (row) {

      var key = row.getAttribute('data-line-key');

      var item = cart.items.filter(function (i) {
        return i.key === key;
      })[0];

      row.querySelector('[data-drawer-inc]').addEventListener(
        'click',
        function () {
          Cart.change(key, item.quantity + 1).then(renderDrawer);
        }
      );

      row.querySelector('[data-drawer-dec]').addEventListener(
        'click',
        function () {
          Cart.change(key, item.quantity - 1).then(renderDrawer);
        }
      );

      row.querySelector('[data-drawer-remove]').addEventListener(
        'click',
        function () {
          Cart.change(key, 0).then(renderDrawer);
        }
      );
    });
  }

  function openDrawer() {
    var d = document.querySelector('[data-cart-drawer]');
    var o = document.querySelector('[data-drawer-overlay]');

    if (!d) return;

    Cart.get().then(renderDrawer);

    d.classList.add('open');

    if (o) {
      o.classList.add('open');
    }

    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var d = document.querySelector('[data-cart-drawer]');
    var o = document.querySelector('[data-drawer-overlay]');

    if (d) {
      d.classList.remove('open');
    }

    if (o) {
      o.classList.remove('open');
    }

    document.body.style.overflow = '';
  }

  window.creomiOpenCart = openDrawer;

  function initCart() {

    document.querySelectorAll('[data-cart-toggle]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });

    document.querySelectorAll(
      '[data-cart-close], [data-drawer-overlay]'
    ).forEach(function (b) {
      b.addEventListener('click', closeDrawer);
    });

    // AJAX add-to-cart forms
    document.querySelectorAll('form[data-product-form]').forEach(function (form) {

      form.addEventListener('submit', function (e) {

        e.preventDefault();

        var btn = form.querySelector('[type="submit"]');
        var id = form.querySelector('[name="id"]').value;

        var qtyField = form.querySelector('[name="quantity"]');
        var qty = qtyField
          ? parseInt(qtyField.value, 10) || 1
          : 1;

        /*
         * ------------------------------------------
         * 商品Aだけ定期購入
         * ------------------------------------------
         *
         * 商品A
         * variant ID  : 48281271763189
         * selling plan: 10201661685
         *
         * その他の商品には selling_plan を付けない
         */

        var items = [{
          id: id,
          quantity: qty
        }];

        if (id === '48281271763189') {
          items[0].selling_plan = '10201661685';
        }

        if (btn) {
          btn.disabled = true;
          btn.dataset.label = btn.textContent;
          btn.textContent = '追加中...';
        }

        Cart.add(items).then(function () {

          if (btn) {
            btn.disabled = false;
            btn.textContent = btn.dataset.label;
          }

          openDrawer();

        }).catch(function (err) {

          if (btn) {
            btn.disabled = false;
            btn.textContent = btn.dataset.label;
          }

          toast(
            (err && err.description)
              ? err.description
              : 'カートに追加できませんでした'
          );
        });
      });
    });

    Cart.get()
      .then(function (cart) {
        updateCartCount(cart.item_count);
      })
      .catch(function () {});
  }

  /* ---------- Placeholder buttons (features handled in Shopify admin) ---------- */
  function initPlaceholders() {
    document.querySelectorAll('[data-toast]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        toast(b.getAttribute('data-toast'));
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initFadeUp();
    initHero();
    initFaq();
    initQty();
    initCart();
    initPlaceholders();
  });

})();


/* ---------- HEADER ---------- */
document.addEventListener('DOMContentLoaded', function () {

  const header = document.querySelector('header');
  const fixedPoint = 32;

  window.addEventListener('scroll', function () {
    header.classList.toggle('fixed', window.scrollY > fixedPoint);
  });

});


/* == rollover ======================================================  */
function smartRollover() {

  if (document.getElementsByTagName) {

    var images = document.getElementsByTagName("img");

    for (var i = 0; i < images.length; i++) {

      if (images[i].getAttribute("src").match("_off.")) {

        images[i].onmouseover = function () {
          $(this).stop(true, true).animate(
            { opacity: '0.4' },
            1000
          );

          this.setAttribute(
            "src",
            this.getAttribute("src").replace("_off.", "_over.")
          );

          $(this).stop(true, true).animate(
            { opacity: '1' },
            400
          );
        };

        images[i].onmouseout = function () {

          $(this).stop(true, true).animate(
            { opacity: '0.4' },
            1000
          );

          this.setAttribute(
            "src",
            this.getAttribute("src").replace("_over.", "_off.")
          );

          $(this).stop(true, true).animate(
            { opacity: '1' },
            400
          );
        };
      }
    }
  }
}

if (window.addEventListener) {
  window.addEventListener("load", smartRollover, false);
}
else if (window.attachEvent) {
  window.attachEvent("onload", smartRollover);
}


/* ---------- HEADER ---------- */
document.addEventListener('DOMContentLoaded', function () {

  const header = document.querySelector('header');
  const fixedPoint = 32;

  window.addEventListener('scroll', function () {
    header.classList.toggle('fixed', window.scrollY > fixedPoint);
  });

});


/* ---------- select ---------- */
document.querySelectorAll('.choice').forEach(select => {

  select.addEventListener('change', function () {

    if (this.value !== '') {
      this.classList.add('is-selected');
    }
    else {
      this.classList.remove('is-selected');
    }

  });

});


/* ---------- subscription auto select ---------- */
function selectSubscription() {

  const group = document.querySelector(
    'input[data-radio-type="selling_plan_group"]'
  );

  const plan = document.querySelector(
    'input[data-radio-type="selling_plan"]'
  );

  if (group && plan) {

    group.checked = true;

    group.dispatchEvent(
      new Event('change', { bubbles: true })
    );

    plan.checked = true;

    plan.dispatchEvent(
      new Event('change', { bubbles: true })
    );

    return true;
  }

  return false;
}

const timer = setInterval(function () {

  if (selectSubscription()) {
    clearInterval(timer);
  }

}, 100);


/* ---------- REVIEW BUTTON ---------- */
(function () {

  function setupReviewButton() {

    const widget =
      document.querySelector('#judgeme_product_reviews');

    const area =
      document.querySelector('#review-write-area');

    if (!widget || !area) return;

    const judgeButton =
      widget.querySelector(
        '[data-testid="write-review-button"]'
      );

    // Judge.me純正ボタンが存在する場合
    if (judgeButton) {

      // 自作ボタンがなければ作成
      if (!area.querySelector('.review-write-button')) {

        const btn = document.createElement('button');

        btn.type = 'button';
        btn.className = 'review-write-button';
        btn.textContent = 'レビューを書く';

        btn.addEventListener('click', function () {
          judgeButton.click();
        });

        area.appendChild(btn);
      }
    }
  }

  const widget =
    document.querySelector('#judgeme_product_reviews');

  if (widget) {

    const observer =
      new MutationObserver(function () {
        setupReviewButton();
      });

    observer.observe(widget, {
      childList: true,
      subtree: true
    });
  }

  setupReviewButton();

})();


/* ---------- REVIEW WIDGET ---------- */
document.addEventListener('DOMContentLoaded', function () {

  function toggleReviewWidget() {

    const widget =
      document.querySelector('#judgeme_product_reviews');

    if (!widget) return;

    const noReview =
      widget.querySelector('.jm-no-reviews-state');

    if (noReview) {
      widget.style.display = 'none';
    }
    else {
      widget.style.display = '';
    }
  }

  toggleReviewWidget();

  const widget =
    document.querySelector('#judgeme_product_reviews');

  if (widget) {

    new MutationObserver(toggleReviewWidget).observe(widget, {
      childList: true,
      subtree: true
    });
  }

});


/* ---------- GUIDE LINK ----------
document.addEventListener('DOMContentLoaded', function () {

  const area =
    document.getElementById('review-write-area');

  if (!area) return;

  if (area.querySelector('.review-guideline')) return;

  area.insertAdjacentHTML(
    'beforeend',
    `
    <p class="review-guideline">
      レビュー投稿前に
      <a href="/pages/review-guidelines" target="_blank" rel="noopener">
        レビューガイドライン
      </a>
      をご確認ください。
    </p>
    `
  );
});
*/ 